var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('li',{on:{"click":_vm.start}},[_c('v-icon',{attrs:{"left":"","color":"red"}},[_vm._v("phone")]),_vm._v(" Dopravní zaměstnanci ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }